import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { ComponentsModule } from './../../components/components.module';
import { DirectivesModule } from './../../directives/directives.module';
import { OrderListPage } from './order-list';

@NgModule({
  declarations: [OrderListPage],
  imports: [
    IonicPageModule.forChild(OrderListPage),
    DirectivesModule,
    ComponentsModule,
  ],
})
export class OrderListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-list/order-list.module.ts